<style>
    table {
        border: 1px solid gainsboro;
        width: 100%;
        border-collapse: collapse;
    }

    th {
        background-color: aliceblue;
        color: black;
        padding: 10px;
        border: 1px solid gainsboro;
    }

    td {
        padding: 10px;
        border: 1px solid gainsboro;
    }
</style>
<script>
    import * as Common from '../Common.js'
    import {onMount} from 'svelte'

    let userId = ""
    let bannedUserEvents = []

    onMount(() => {
        Common.getData('banevents')
        .then(data => {
            if(!data) {
                alert("Problem getting info!")
                return
            }
            bannedUserEvents = data
        })
    })

    function createLink(eventType, refId) {
        switch(eventType) {
            case Common.ShadowBanReason_BannedIP:
                return "<i>Ip Ban</i>";
            case Common.ShadowBanReason_UserValue:
                return '<a href="#/user/' + refId + '">user/' + refId + '</a>'
            case Common.ShadowBanReason_ItemValue:
                return '<a href="#/item/' + refId + '">item/' + refId + '</a>'
            case Common.ShadowBanReason_CommentValue:
                return '<a href="#/comment/' + refId + '">comment/' + refId + '</a>'
            default:
                return ''
        }
    }

    function banUser(event) {
        Common.postData('banuser/' + userId)
        .then(r => {
            if(!r.ok) {
                alert("Problem banning user!")
                return
            }
            alert("User successfully banned.");
            userId = "";
        })
    }

    function unBan(b) {
        Common.postData('reversebanevent/' + b.id)
          .then(r => {
            if(!r.ok) {
                alert("Problem reversing ban event");
                return
            }
            bannedUserEvents = bannedUserEvents.filter(be => be.id != b.id)
        })
    }

    function ignore(b) {
        Common.postData('ignorebanevent/' + b.id)
        .then(r => {
            if(!r.ok) {
                alert("Problem ignoring ban event");
                return
            }
            bannedUserEvents = bannedUserEvents.filter(be => be.id != b.id)
        })
    }
</script>
<div style="padding: 10px;">
    <h2>Banned User Events</h2>
    <p>
        The following table contains users that have been automatically banned due to use of potentially offensive words.
    </p>
</div>
<div style="padding: 10px;">
    <input type="text" bind:value={userId}>
    <button on:click={banUser}>BanUser</button>
</div>
<table>
    <tr>
        <th>Id</th>
        <th>Banned Time</th>
        <th>User</th>
        <th>Link</th>
        <th>Details</th>
        <th>Actions</th>
    </tr>
    {#each bannedUserEvents as b}
        <tr>
            <td>{b.id}</td>
            <td>{Common.UnixTimeToDateStr(b.createtime)}</td>
            <td><a href={"#/user/" + b.user_id}>user/{b.user_id}</a></td>
            <td>{@html createLink(b.eventtype, b.ref_id)}</td>
            <td>'{b.details}'</td>
            <td>
                <button on:click={() => unBan(b)}>Unban</button>
                <button on:click={() => ignore(b)}>Ignore</button>
            </td>
        </tr>
    {/each}
</table>